<template>
  <el-container class="home-wrap">
    <el-main class="full-content buy-table">
      <div class="flex-row-center buy-header" style="padding: 20px 0;">
        <p>{{$t('Browser Histroy')}}</p>
      </div>
      <div class="flex-row-between bh-header">
        <p>{{$t('Enable Brower History')}}</p>
        <el-switch
          v-model="value"
          @change="switchange"
          active-color="#13ce66"
          inactive-color="#C0CCDA">
        </el-switch>
      </div>
      <div class="flex-row-start b_header">
        <p>{{$t('It will record the browsing history of Chrome, Firefox, Edge and other browsers after you enable it.')}}</p>
      </div>
      <el-radio-group v-model="tabPosition" style="margin: 38px 0;border-radius: 30px;width:100%;"  @change="changeTheme">
        <el-radio-button :label="0">{{$t('Today')}}</el-radio-button>
        <el-radio-button :label="1">{{$t('Yesterday')}}</el-radio-button>
        <el-radio-button :label="2">{{$t('Last 7 Days')}}</el-radio-button>
      </el-radio-group>
      <div v-if="allDates.length > 0" style="overflow: hidden;position: relative;height: 60%;">
        <div class="b_content" v-loading="isloading">
          <div v-for="(date, i) in allDates" :key="i" class="flex-row-start" style="height: 60px;width: 100%;">
            <div class="histroy_date">{{dateFormatter(date.date)}}</div>
            <div class="flex-row-between histroy_center">
              <div class="flex-col-center" style="text-align: left;padding-right: 20px;width: 90%;">
                <a class="histroy_com" target="_blank" :href="date.url">{{date.url}}</a>
                <div v-if="date.type !== 'Unknown'" class="histroy_Game">
                <span class="histroy_type">{{date.type}}</span>
                </div>
              </div>
              <img class="histroy_edit" @click="histroyEdit(date.url)" :src="$Image('edit_s.png')" alt="">
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex-col-center" style="height: 50%;">
        <div><img :src="$Image('nodata.png')" alt=""></div>
        <div class="nodata-found">{{$t('No data found')}}</div>
      </div>
    </el-main>
    <router-view/>
  </el-container>
</template>
<script>
export default {
  name: 'BrowserHistroy',
  props: ['userid', 'device'],
  data () {
    return {
      value: false,
      tabPosition: 0,
      allDates: [],
      isloading: false
    }
  },
  methods: {
    async changeTheme (tab) {
      this.isloading = true
      try {
        let today = ['Today', 'Yesterday', 'Last 7 Days']
        console.log(tab)
        const datas = await this.$http.get(`MDM/BrowserHistory?date=${today[tab]}`)
        console.log(datas.data)
        this.value = datas.data.status
        this.allDates = datas.data.data
      } catch (error) {
        console.log(error)
      }
      this.isloading = false
    },
    async switchange () {
      // console.log(v, this.tabPosition)
      const success = await this.$http.get('MDM/EnableModule', {
        params: {
          status: this.value,
          module: 'BrowserHistory'
        }
      })
      console.log(success)
      this.changeTheme(this.tabPosition)
    },
    histroyEdit (u) {
      console.log(u)
      this.$router.push({ path: `/User/${this.$route.params.userid}/${this.$route.params.device}/WebsiteFilter`, query: {url: u, Setting: true} })
    },
    dateFormatter: function (aDate) {
      let date = this.$Formatter.dateHistroy(aDate * 1000)
      return date
    }
  },
  mounted () {
    this.changeTheme(this.tabPosition)
  },
  watch: {
    '$route' (to, from) {
      console.log(to, from)
      if (to.name === from.name) {
        this.changeTheme(this.tabPosition)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-wrap{
  width:100%;
  height:90%;
  box-sizing: border-box;
  .buy-table{
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    height: 100%;
    .buy-header{
      width:100%;
      box-sizing: border-box;
      border-bottom:1px solid #e5e5e5;
      color: #333333;
      font-size: 24px;
    }
  }
}
.nodata-found{
  font-size: 18px;font-weight: normal;line-height: 54px;color: #777777;margin-top: 20px;margin-top: 30px;
}
.bh-header {
  padding: 15px;
}
.b_header{
  background-color: #f3f3f3;
  padding: 15px;
  color: #888888;
  font-size: 14px;
}
.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 30px 0 0 30px !important;
}
.b_content {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.b_content::-webkit-scrollbar {
    display: none;
}
.histroy_date {
  padding: 0 30px;
  color: #777777;
  font-size: 15px;
}
.histroy_center {
  width: 100%;
  border-bottom: solid 1px #f3f3f3;
  padding: 0 40px 10px 0;
  display: -webkit-box;
  // -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.histroy_com {
  color: #2bcf88;
  text-align: left;
  font-size: 16px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  float: right;
}
.histroy_Game {
  text-align: left;
  width: 100%;
  margin-top: 10px;
}
.histroy_type{
  // border: solid 1px #161616;
  border-radius: 10px;
  background-color: #fff2e6;
  padding: 3px;
  font-size: 12px;
  color: #f8a353;
}
.histroy_edit{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BrowserHistroy.vue